const presentations = {
  client: { authorLabel: 'Client', tone: 'emerald' },
  staff: { authorLabel: 'Staff', tone: 'blue' },
  system: { authorLabel: 'System', tone: 'violet' },
}

export const replyPresentation = note => presentations[note.author_type] ?? {}
